import React from 'react'
import useState from 'App/hooks/useState'
import getTextFromNumber from './getTextFromNumber'
import getPrettyText from './getPrettyText'
import getValueFromText from './getValueFromText'
import useEffect from 'App/hooks/useEffect'

export default function Input({value, onChange, passProps}) {
  const [textValue, setTextValue] = useState(getTextFromNumber(value))
  const [focused, setFocused] = useState()

  useEffect(() => {
    if (focused) return

    const newTextValue = getTextFromNumber(value)
    if (textValue !== newTextValue) {
      setTextValue(newTextValue)
    }
  }, [value, focused])

  const updateValue = text => {
    onChange(getValueFromText(text))
  }

  return (
    <input
      className="os-input-text"
      value={focused ? textValue : getPrettyText(value)}
      onChange={event => {
        setTextValue(event.target.value)
        updateValue(event.target.value)
      }}
      onFocus={() => setFocused(true)}
      onBlur={event => {
        setFocused(false)
        if (passProps.onBlur) {
          passProps.onBlur(event)
        }
      }}
      onKeyDown={event => {
        if (passProps.onKeyDown) {
          passProps.onKeyDown(event)
        }
      }}
    />
  )
}
